module.exports = __webpack_public_path__ + "media/images/trash-icon-e3766958.svg";